import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const GET_CHECKLISTE_VER_TYP = '[VorlagenModul] GetChecklisteVerTyp laden';
export const GET_CHECKLISTE_VER_TYP_AUSFUEHREN = '[VorlagenModul] GetChecklisteVerTyp ausführen';
export const GET_CHECKLISTE_VER_TYP_ERFOLGREICH = '[VorlagenModul] GetChecklisteVerTyp laden erfolgreich';
export const GET_CHECKLISTE_VER_TYP_FEHLER = '[VorlagenModul] GetChecklisteVerTyp Ladefehler';
export const GET_CHECKLISTE_VER_TYP_NICHT_AUSGEFUEHRT = '[VorlagenModul] GetChecklisteVerTyp nicht ausgeführt (evtl. Offline)';


export class GetChecklisteVerTypAction implements Action {
    readonly type = GET_CHECKLISTE_VER_TYP;
        constructor( public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteVerTypAusfuehrenAction implements Action {
    readonly type = GET_CHECKLISTE_VER_TYP_AUSFUEHREN;
        constructor( public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteVerTypErfolgreichAction implements Action {
    readonly type = GET_CHECKLISTE_VER_TYP_ERFOLGREICH;
        constructor(public payload: api.ChecklisteVerTyp,  public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteVerTypFehlerAction implements Action {
    readonly type = GET_CHECKLISTE_VER_TYP_FEHLER;
        constructor(public payload: any,  public checkliste_id:string , public optPayload: any = null) {}
    }
export class GetChecklisteVerTypNichtAusgefuehrtAction implements Action {
    readonly type = GET_CHECKLISTE_VER_TYP_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenQueryChecklisteVerTypActions =
    GetChecklisteVerTypAction
    | GetChecklisteVerTypAusfuehrenAction
    | GetChecklisteVerTypErfolgreichAction
    | GetChecklisteVerTypFehlerAction
    | GetChecklisteVerTypNichtAusgefuehrtAction
    ;
